var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEleclercAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5626_627)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#0B70B5",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 10,
    r: 20,
    fill: "#ED8B18",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5626_627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 56C24.9719 56 16 47.0285 16 36C16 24.9719 24.9715 16 36 16C47.0285 16 56 24.9719 56 36C56 47.0285 47.0281 56 36 56ZM36 20.2288C27.3033 20.2288 20.2293 27.3037 20.2293 36.0004C20.2293 44.6971 27.3038 51.772 36 51.772C44.6962 51.772 51.7716 44.6967 51.7716 36.0004C51.7716 27.3042 44.6967 20.2288 36 20.2288Z",
    fill: "#0B70B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2341 41.2346C40.2341 41.2346 39.4315 43.4155 36.219 43.4155H33.4579V31.6747C33.4579 30.7574 34.2614 29.8937 35.1787 29.8937H35.2027V27.2766H26.9151V29.8937H26.8929C27.8106 29.8937 28.6599 30.7574 28.6599 31.6747V41.6394C28.6599 42.5571 27.8106 43.4151 26.8929 43.4151H26.9151V47.3407H36.2923H42.1816V41.2341L40.2341 41.2346Z",
    fill: "#0B70B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.044 23.4414C35.6136 23.4414 33.3685 24.2235 31.5557 25.532H36.9474V31.0803C35.6389 31.2832 35.2027 32.1669 35.2027 33.2264V41.6709H36.7302C38.1408 41.6709 39.2758 40.7985 39.3508 39.49H43.9264V43.5047C46.9797 41.5553 48.8946 38.1784 48.8946 34.3687C48.8946 28.3476 44.0651 23.4414 38.044 23.4414Z",
    fill: "#ED8B18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5626_627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5626_627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEleclercAppIcon);
export default __webpack_public_path__ + "static/media/eleclerc-app-icon.49fff56d95abdb0c64ccc0eea2bfc77b.svg";
export { ForwardRef as ReactComponent };